import { Navigate } from "react-router-dom";

export default function DoctorRoute({ isDocLoggedIn, children }) {
    if (!isDocLoggedIn) {
        return <Navigate to="/DoctorLogin" replace />;
    }
    return children;
}
